import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"

import { PrincipalActivities } from "@/features/settings/components/principal-activities"
import { firmRecordQueries } from "@/queries/firm-record"
import { permissionQueries } from "@/queries/permissions"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/activities/"
)({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(firmRecordQueries.permissions()),
      context.queryClient.ensureQueryData(permissionQueries.groups()),
    ]),
  component: ActivitiesSettingsPage,
})

function ActivitiesSettingsPage() {
  const { data: held } = useSuspenseQuery(firmRecordQueries.permissions())
  const { data: catalogue } = useSuspenseQuery(permissionQueries.groups())
  const navigate = useNavigate()

  return (
    <PrincipalActivities
      held={held}
      groups={catalogue.data}
      onSaved={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/settings/organisation/authorisation",
        })
      }
    />
  )
}
